<template>
  <div class="echarts1" ref="echarts">
  </div>
</template>

<script>

import {FontChart} from "@/utils/utils";
import Axios from "@/utils/Axios";
import Bus from "@/utils/bus.js";

export default {
  name: 'echarts1',
  components: {},
  props: {
    id: {
      type: String,
      default() {
        return ''
      }
    },
    active: {
      type: Number,
      default() {
        return ''
      }
    },
  },
  data() {
    return {
      status: '',
      month:null,
      time:null,
      depid:null,
    }
  },
  watch: {
    active(){
      if(this.active==0){
        this.getdaypowdata()

      }else if(this.active==1){
        this.getpowdata()

      }
    }
  },
  mounted() {
    let that=this
    this.getnowtime()
    this.getdaypowdata(0)
    Bus.$on('changeid',(val)=>{
      this.depid=val.deptId
      if(this.active==0){
        this.getdaypowdata(0)

      }else if(this.active==1){
        this.getpowdata()

      }
    })
  },
  methods: {
    getnowtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期

      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      var MS = now.getMilliseconds(); //获取毫秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      if (MS < 100) MS = "0" + MS;

      var time = "";
      time =
        year + "-" + month + "-" + date

      var yesnow = new Date();
      yesnow.setTime(yesnow.getTime() - 30 * 24 * 60 * 60 * 1000);
      var yesyear = yesnow.getFullYear(); //得到年份
      var yesmonth = yesnow.getMonth(); //得到月份
      var yesdate = yesnow.getDate(); //得到日期

      var yeshour = yesnow.getHours(); //得到小时
      var yesminu = yesnow.getMinutes(); //得到分钟
      var yessec = yesnow.getSeconds(); //得到秒
      var yesMS = yesnow.getMilliseconds(); //获取毫秒
      yesmonth = yesmonth + 1;
      if (yesmonth < 10) yesmonth = "0" + yesmonth;
      if (yesdate < 10) yesdate = "0" + yesdate;
      if (yeshour < 10) yeshour = "0" + yeshour;
      if (yesminu < 10) yesminu = "0" + yesminu;
      if (yessec < 10) yessec = "0" + yessec;
      if (yesMS < 100) yesMS = "0" + yesMS;
      var yestime = "";
      yestime =
        yesyear +
        "-" +
        yesmonth +
        "-" +
        yesdate


      this.month = year + "-" + month;
      this.time = time;

    },
    drawLine(data) {

      var that = this;
      let xdata=[]
      let ydata1=[]
      let ydata2=[]
      for(let i=0;i<data.energyTrends.length;i++){
        xdata.push(data.energyTrends[i].dataTime)
        ydata1.push((data.energyTrends[i].energy).toFixed(2))
        ydata2.push((data.energyTrends[i].lastPeriodEnergy).toFixed(2))
      }

      window.addEventListener('resize', this.drawLine)
      let myChart = this.$echarts.init(that.$refs.echarts)
      var option = {
        title: {
          left: "50%",
          textAlign: "center",
        },
        tooltip: {
          show: true,
          trigger: 'axis',
        },
        legend: {
          right: 20,
          orient: "vertical",
          data: ["本月", "上月"],
          textStyle: {
            color: "#7588E4",
          },
        },
        xAxis: {
          type: "category",
          data: xdata,
          boundaryGap: false,
          splitLine: {
            show: true,
            interval: "auto",
            lineStyle: {
              color: ["#355ebb"],
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#355ebb",
            },
          },
          axisLabel: {
            margin: 10,
            textStyle: {
              fontSize: 14,
            },
          },
        },
        grid: {
          x: 80,
          y: 25,
          x2: 30,
          y2: 35
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              color: ["#355ebb"],
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#355ebb",
            },
          },
          axisLabel: {
            margin: 10,
            textStyle: {
              fontSize: 14,
            },
          },
        },
        series: [
          {
            name: "能耗",
            type: "line",
            smooth: true,
            showSymbol: false,
            symbol: "circle",
            symbolSize: 6,
            data: ydata1,
            areaStyle: {
              normal: {
                color: this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(199, 237, 250,0.5)",
                    },
                    {
                      offset: 1,
                      color: "rgba(199, 237, 250,0.1)",
                    },
                  ],
                  false
                ),
              },
            },
            itemStyle: {
              normal: {
                color: "#f7b851",
              },
            },
            lineStyle: {
              normal: {
                width: 1,
              },
            },
          },
          {
            name: "上期能耗",
            type: "line",
            smooth: true,
            showSymbol: false,
            symbol: "circle",
            symbolSize: 6,
            data:ydata2,
            areaStyle: {
              normal: {
                color: this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(216, 244, 247,0.5)",
                    },
                    {
                      offset: 1,
                      color: "rgba(216, 244, 247,0.1)",
                    },
                  ],
                  false
                ),
              },
            },
            itemStyle: {
              normal: {
                color: "#58c8da",
              },
            },
            lineStyle: {
              normal: {
                width: 1,
              },
            },
          },
        ],
      }
      myChart.clear()
      myChart.resize()
      myChart.setOption(option)
    },
    getpowdata(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/portal/deptDayEnergyTrendTotal"

      param.data={
        deptId:this.depid,
      }
      param.data.yearMonth=this.month
      Axios.ajax(param).then((res)=>{
        if(res.resultCode=='0'){
         this.drawLine(res.data)
          this.$emit('gettitledata',[res.data.energyTotal,res.data.lastPeriodEnergyTotal])
        }else{

        }

      })
    },
    getdaypowdata(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/portal/deptHourEnergyTrendTotal"

      param.data={
        deptId:this.depid,
      }
      param.data.localDate=this.time
      Axios.ajax(param).then((res)=>{
        if(res.resultCode=='0'){

          this.$emit('gettitledata',[res.data.energyTotal,res.data.lastPeriodEnergyTotal])
          this.drawLine(res.data)


        }else{

        }

      })
    },
  }
}
</script>

<style lang="scss" scoped>
.echarts1 {
  position: relative;
  width: 100%;
  height: calc(100% - 0px);
}
</style>
